// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/collection-list/collection-list';
import 'sections/collection-list/collection-list';
import 'sections/banner/banner-block';
import 'sections/icon-block/icon-block';
import 'sections/content-panel/content-panel';
import 'sections/faqs/faqs';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/footer/footer';

// Styles